// extracted by mini-css-extract-plugin
module.exports = {"selector":"bDteb","selectorText":"_3-Ror","selectorItem":"_3f_io"};